<template>
  <Box class="ReviewExternal">
    <div class="overview">
      <div class="scores">
        <strong>
          {{ reviewExternal.scorePercent }}%
        </strong>
        <div v-if="hasScoreConversion">
          ({{ reviewExternal.scoreOriginal }})
        </div>
        <div class="matchScore">
          {{ $t('match', [reviewExternal.matchScore]) }}
        </div>
      </div>
      <div class="summary">
        {{ reviewExternal.summary }}
      </div>
    </div>
    <div class="prosCons">
      <ul>
        <li v-for="(pro, index) in reviewExternal.pros" :key="index">
          <Icon name="plus" /> {{ pro }}
        </li>
      </ul>
      <ul>
        <li v-for="(con, index) in reviewExternal.cons" :key="index">
          <Icon name="minus" /> {{ con }}
        </li>
      </ul>
    </div>
  </Box>
</template>

<script>
export default {
  props: {
    reviewExternal: { type: Object, required: true },
  },
  computed: {
    hasScoreConversion() {
      const { scoreOriginal, scorePercent } = this.reviewExternal

      return parseInt(scoreOriginal, 10) !== scorePercent
    },
  },
}
</script>

<style lang="scss">
.ReviewExternal {
  margin-top: $u;
  padding: $u;

  .overview {
    display: grid;
    grid-template-columns: 8rem 1fr;
    padding: 0 $u $u;

    .scores {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;

      > strong {
        color: $info;
        font-size: $h3;
        font-weight: $bold;
      }
    }
  }

  .prosCons {
    display: grid;
    grid-template-columns: 1fr 1fr;

    ul {
      list-style: none;
    }
  }

  .matchScore {
    color: $text-color-light;
    font-size: $h6;
  }
}
</style>

<i18n>
{
  "en": {
    "match": "Match score - {0}"
  }
}
</i18n>
